import { render } from "./Inquiry.vue?vue&type=template&id=46e73c5e&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=46e73c5e&scoped=true&lang=css"

import exportComponent from "D:\\project\\weshow-front-rococo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e73c5e"]])

export default __exports__